import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable, of, throwError } from 'rxjs';
import { Subject } from 'rxjs';
import { environment } from 'src/environments/environment';
import { UtilService } from './util.service';
import { ProductConversionsService } from './product-conversions.service';
import { DomSanitizer } from '@angular/platform-browser';
import { AuthService } from '../auth/auth.service';
import { take, catchError, tap, map } from 'rxjs/operators';
import * as _ from "lodash";

const BackendUrl = environment.BackendUrl;

@Injectable({
  providedIn: 'root'
})

export class ProductService {

  getProductDataUpdated = new Subject<any>();
  getProductsDataUpdated = new Subject<any>();
  getProductSingleDataUpdated = new Subject<any>();
  getProductRestDataUpdated = new Subject<any>();
  getProducthistoryDataUpdated = new Subject<any>();
  getProductPphraseDataUpdated = new Subject<any>();
  getProductCphraseDataUpdated = new Subject<any>();
  getProductCasDataUpdated = new Subject<any>();
  getProductSubstanceGroupsDataUpdated = new Subject<any>();
  getProductRestrictionDataUpdated = new Subject<any>();
  getProductGroupDataUpdated = new Subject<any>();
  getProductCategoryDataUpdated = new Subject<any>();
  getProductLangDataUpdated = new Subject<any>();
  getProductCargoDataUpdated = new Subject<any>();
  getProductDepartmentDataUpdated = new Subject<any>();
  getProductPictureDataUpdated = new Subject<any>();
  getChangedProductsDataUpdated = new Subject<any>();
  getProductStyrenDataUpdated = new Subject<any>();
  getAllProductDataUpdated = new Subject<any>();
  getProductsAllSupUpdated = new Subject<any>();
  getProductsCountUpdated = new Subject<any>();
  getDataSheetUpdated = new Subject<any>();
  getSdsDataUpdated = new Subject<any>();  // For SDS requests
  getGrbDataUpdated = new Subject<any>();   // For GRB requests
  getExtSdsDataUpdated = new Subject<any>(); // For ExtSDS requests
  getHistoryStatisticsUpdated = new Subject<any>();
  getProductRestTwoDatesUpdated = new Subject<any>();
  getProductsAllSupTopUpdated = new Subject<any>();
  getLogoUpdated = new Subject<any>();
  getProductNumberDataUpdated = new Subject<any>();
  getCheckProductDataUpdated = new Subject<any>();
  getDeletedProductsForCustomerUpdated = new Subject<any>();
  getRevisionStatusUpdated = new Subject<any>();
  /** Header product badge. Emitted after a product is added, updated, or removed. */
  productListChanged = new Subject<void>();

  constructor(private http: HttpClient, private utilService: UtilService, private sanitizer:DomSanitizer,
               private authService: AuthService, private productConversionsService: ProductConversionsService) {}

  /** Ask the header to recount the product badge from the existing product list. */
  notifyProductListChanged(): void {
    this.productListChanged.next();
  }

  fetchLabels(organisationId, productId, size, thistoken) {

   let token = localStorage.getItem('token');

    const headers = new HttpHeaders({'Accept':'application/json','Authorization':token});
    let params = new HttpParams();
    params = params.append("data", size);
    params = params.append("token", thistoken);

    this.http.get(BackendUrl + "/organisations/" + organisationId + "/products/labels/" + productId, {headers: headers, params: params, responseType: "arraybuffer"})
      .pipe(take(1)).subscribe({next: response => {

        var contentType = 'application/vnd.openxmlformats-officedocument.wordprocessingml.document';
        var file = new Blob([response], { type: contentType });
        var fileURL = URL.createObjectURL(file);
        this.getProductDataUpdated.next(fileURL);
      },
      error: error => {
        if (error.status === 401)
        {
          this.authService.logout();
        }
        this.getProductDataUpdated.next(null);
      }
    });
  }

  fetchLabelsDepartmentAllWord(organisationId, labelInfo) {
    let token = localStorage.getItem('token');

    const headers = new HttpHeaders({'Accept':'application/json','Authorization':token});
    let params = new HttpParams();
    params = params.append("labelSortType", labelInfo.labelSortType);
    params = params.append("labelSortOrder", labelInfo.labelSortOrder);
    params = params.append("labelSortSubDepartments", labelInfo.labelSortSubDepartments);

    this.http.get(BackendUrl + "/organisations/" + organisationId + "/products/labelsfordepartmentallword", {headers: headers, params: params, responseType: "arraybuffer"})
      .pipe(take(1)).subscribe({next: response => {

        var contentType = 'application/vnd.openxmlformats-officedocument.wordprocessingml.document';
        var file = new Blob([response], { type: contentType });
        var fileURL = URL.createObjectURL(file);
        this.getProductDataUpdated.next(fileURL);
      },
      error: error => {
        if (error.status === 401)
        {
          this.authService.logout();
        }
        this.getProductDataUpdated.next(null);
      }
    });
  }

  fetchLabelsDepartmentAllPDF(organisationId, labelInfo) {
    let token = localStorage.getItem('token');

    const headers = new HttpHeaders({'Accept':'application/json','Authorization':token});
    let params = new HttpParams();
    params = params.append("labelSortType", labelInfo.labelSortType);
    params = params.append("labelSortOrder", labelInfo.labelSortOrder);
    params = params.append("labelSortSubDepartments", labelInfo.labelSortSubDepartments);

    this.http.get(BackendUrl + "/organisations/" + organisationId + "/products/labelsfordepartmentallpdf", {headers: headers, params: params, responseType: "arraybuffer"})
      .pipe(take(1)).subscribe({next: response => {

        var contentType = 'application/pdf';
        var file = new Blob([response], { type: contentType });
        var fileURL = URL.createObjectURL(file);
        this.getProductDataUpdated.next(fileURL);
      },
      error: error => {
        if (error.status === 401)
        {
          this.authService.logout();
        }
        this.getProductDataUpdated.next(null);
      }
    });
  }

  fetchQRLogin(department,subDeps) {

    let token = localStorage.getItem('token');

     const headers = new HttpHeaders({'Accept':'application/json','Authorization':token});
     let params = new HttpParams();
     params = params.append("departmentid", department.id);
     params = params.append("departmentname", department.name);
     params = params.append("departmentfullpath", department.fullpath);
     params = params.append("subDeps", subDeps);

     this.http.get(BackendUrl + "/organisations/products/labels/qrlogin", {headers: headers, params: params, responseType: "arraybuffer"})
       .pipe(take(1)).subscribe({next: response => {
         var contentType = 'application/vnd.openxmlformats-officedocument.wordprocessingml.document';
         var file = new Blob([response], { type: contentType });
         var fileURL = URL.createObjectURL(file);
         this.getProductDataUpdated.next(fileURL);
       },
       error: error => {
         if (error.status === 401)
         {
           this.authService.logout();
         }
         this.getProductDataUpdated.next(null);
       }
     });
   }

  moveProduct (productId, oldDepartmentId, newDepartmentId, LRBInfo, comment) {
    if (localStorage.getItem("selectedDepartment") != null) {
      var orgId = JSON.parse(localStorage.getItem("selectedDepartment")).id;
      if (orgId == null) {
        this.authService.logout();
      }
      var info = {
        "productId":productId,
        "oldDepartmentId":oldDepartmentId,
        "newDepartmentId":newDepartmentId,
        "LRBInfo": LRBInfo ? LRBInfo : null,
        "comment": comment || null
      };
    }
    let token = localStorage.getItem("token");
    const headers = new HttpHeaders({
      Accept: "application/json",
      Authorization: token,
    });
    this.http
      .put<any>(
        BackendUrl + "/organisations/" + orgId + "/moveproduct",
        info,
        { headers: headers }
      )
      .pipe(take(1))
      .subscribe({
        next: (response) => {
          this.getProductDataUpdated.next(response);
        },
        error: (error) => {
          if (error.status === 401) {
            this.authService.logout();
          }
          this.getProductDataUpdated.next(null);
        },
      });
  }

  getLabelForPrinter(organisationId, productId, size, thistoken) {

    let token = localStorage.getItem('token');

    const headers = new HttpHeaders({'Accept':'application/json','Authorization':token});
    let params = new HttpParams();
    params = params.append("data", size);
    params = params.append("token", thistoken);

    this.http.get(BackendUrl + "/organisations/" + organisationId + "/products/printer/" + productId, {headers: headers, params: params, responseType: "arraybuffer"})
      .pipe(take(1)).subscribe({next: response => {

        var contentType = 'application/pdf';
        var file = new Blob([response], { type: contentType });
        var fileURL = URL.createObjectURL(file);
        this.getProductDataUpdated.next(fileURL);
      },
      error: error => {
        if (error.status === 401)
        {
          this.authService.logout();
        }
        this.getProductDataUpdated.next(null);
      }
    });
  }

  getQRCodeDepartment(organisationId, thistoken) {
    let token = localStorage.getItem('token');
    const headers = new HttpHeaders({'Accept':'application/json','Authorization':token});
    let params = new HttpParams();
    params = params.append("token", thistoken);
    this.http.get(BackendUrl + "/organisations/" + organisationId + "/products/getqrcodedepartment/", {headers: headers, params: params, responseType: "arraybuffer"})
      .pipe(take(1)).subscribe({next: response => {
        var contentType = 'application/pdf';
        var file = new Blob([response], { type: contentType });
        var fileURL = URL.createObjectURL(file);
        this.getProductDataUpdated.next(fileURL);
      },
      error: error => {
        if (error.status === 401)
        {
          this.authService.logout();
        }
        this.getProductDataUpdated.next(null);
      }
    });
  }

  createNewGroup(orgId, groupName) {
    let token = localStorage.getItem('token');

    const headers = new HttpHeaders({'Accept':'application/json','Authorization':token});

    var info = {
      name: groupName,
    }

    this.http.post(BackendUrl + "/organisations/" + orgId + "/groups", info, {headers: headers})
      .pipe(take(1)).subscribe({next: response => {

        this.getProductDataUpdated.next(response);
      },
      error: error => {
        if (error.status === 401)
        {
          this.authService.logout();
        }
        this.getProductDataUpdated.next(null);
      }
    });
  }

  updateGroup(orgId, group) {
    let token = localStorage.getItem('token');

    const headers = new HttpHeaders({'Accept':'application/json','Authorization':token});

    var info = {
      name: group.name,
    }

    this.http.put(BackendUrl + "/organisations/" + orgId + "/groups/" + group.id, info, {headers: headers})
      .pipe(take(1)).subscribe({next: response => {

        this.getProductDataUpdated.next(response);
      },
      error: error => {
        if (error.status === 401)
        {
          this.authService.logout();
        }
        this.getProductDataUpdated.next(null);
      }
    });
  }

  removeGroup(orgId, group) {
    let token = localStorage.getItem('token');

    const headers = new HttpHeaders({'Accept':'application/json','Authorization':token});
    this.http.delete(BackendUrl + "/organisations/" + orgId + "/groups/" + group.id, {headers: headers}).pipe(take(1)).subscribe({next: response => {

        this.getProductDataUpdated.next(true);
      },
      error: error => {
        if (error.status === 401)
        {
          this.authService.logout();
        }
        this.getProductDataUpdated.next(true);
      }
    });
  }

  getProductsWithLessInformation(orgId) {

    let token = localStorage.getItem('token');

    const headers = new HttpHeaders({'Accept':'application/json','Authorization':token});

    this.http.get(BackendUrl + '/organisations/' + orgId + '/products/subForUI', this.utilService.setHeadersAndParamsObject())
      .pipe(take(1)).subscribe({next: response => {
        this.getProductDataUpdated.next(response);
      },
      error: error => {
        if (error.status === 401)
        {
          this.authService.logout();
        }
        this.getProductDataUpdated.next(null);
      }
    });
  }

  getGroups(orgId) {
    let token = localStorage.getItem('token');

    const headers = new HttpHeaders({'Accept':'application/json','Authorization':token});

    this.http.get<any>(BackendUrl + "/organisations/" + orgId + "/groups", {headers: headers})
      .pipe(take(1)).subscribe({next: response => {

        this.getProductGroupDataUpdated.next(response);
      },
      error: error => {
        if (error.status === 401)
        {
          this.authService.logout();
        }
        this.getProductGroupDataUpdated.next(null);
      }
    });
  }

  createNewCategory(orgId, categoryName) {
    let token = localStorage.getItem('token');

    const headers = new HttpHeaders({'Accept':'application/json','Authorization':token});

    var info = {
      name: categoryName,
    }

    this.http.post(BackendUrl + "/organisations/" + orgId + "/productcategories", info, {headers: headers})
      .pipe(take(1)).subscribe({next: response => {

        this.getProductDataUpdated.next(response);
      },
      error: error => {
        if (error.status === 401)
        {
          this.authService.logout();
        }
        this.getProductDataUpdated.next(null);
      }
    });
  }

  updateCategory(orgId, category) {
    let token = localStorage.getItem('token');

    const headers = new HttpHeaders({'Accept':'application/json','Authorization':token});

    var info = {
      name: category.name,
    }

    this.http.put(BackendUrl + "/organisations/" + orgId + "/productcategories/" + category.id, info, {headers: headers})
      .pipe(take(1)).subscribe({next: response => {

        this.getProductDataUpdated.next(response);
      },
      error: error => {
        if (error.status === 401)
        {
          this.authService.logout();
        }
        this.getProductDataUpdated.next(null);
      }
    });
  }

  removeCategory(orgId, category) {
    let token = localStorage.getItem('token');

    const headers = new HttpHeaders({'Accept':'application/json','Authorization':token});
    this.http.delete(BackendUrl + "/organisations/" + orgId + "/productcategories/" + category.id, {headers: headers}).pipe(take(1)).subscribe({next: response => {

        this.getProductDataUpdated.next(true);
      },
      error: error => {
        if (error.status === 401)
        {
          this.authService.logout();
        }
        this.getProductDataUpdated.next(true);
      }
    });
  }

  getCategories(orgId) {
    let token = localStorage.getItem('token');

    const headers = new HttpHeaders({'Accept':'application/json','Authorization':token});

    this.http.get<any>(BackendUrl + "/organisations/" + orgId + "/productcategories", {headers: headers})
      .pipe(take(1)).subscribe({next: response => {

        this.getProductCategoryDataUpdated.next(response);
      },
      error: error => {
        if (error.status === 401)
        {
          this.authService.logout();
        }
        this.getProductCategoryDataUpdated.next(null);
      }
    });
  }

  getSdsAsTrustedResourceUrl(sareqId) {
    let token = localStorage.getItem('token');
    const headers = new HttpHeaders({'Accept':'application/json','Authorization':token});
    let params = new HttpParams();
    params = params.append("token", token);
    var file,fileURL,contentType;

    this.http.get(BackendUrl + "/sareq/" + sareqId + "/sds", {headers: headers, responseType: "arraybuffer"})
      .pipe(take(1)).subscribe({next: response => {
        if(response==null||response.byteLength==0){
          this.getSdsDataUpdated.next(null);
        } else {
          contentType = 'application/pdf';
          file = new Blob([response], { type: contentType });
          fileURL = URL.createObjectURL(file);
          this.getSdsDataUpdated.next(fileURL);
        }
      },
      error: error => {
        if (error.status === 401)
        {
          this.authService.logout();
        }
        this.getSdsDataUpdated.next(null);
      }
    });
  }

  getGrbAsTrustedResourceUrl(sareqId) {
    let token = localStorage.getItem('token');
    const headers = new HttpHeaders({'Accept':'application/json','Authorization':token});
    let params = new HttpParams();
    params = params.append("token", token);
    var file,fileURL,contentType;

    this.http.get(BackendUrl + "/sareq/" + sareqId + "/grb", {headers: headers, responseType: "arraybuffer"})
      .pipe(take(1)).subscribe({next: response => {
        if(response==null||response.byteLength==0){
          this.getGrbDataUpdated.next(null);
        } else {
          contentType = 'application/pdf';
          file = new Blob([response], { type: contentType });
          fileURL = URL.createObjectURL(file);
          this.getGrbDataUpdated.next(fileURL);
        }

      },
      error: error => {
        if (error.status === 401)
        {
          this.authService.logout();
        }
        this.getGrbDataUpdated.next(null);
      }
    });
  }

  getStampedSdsAsTrustedResourceUrl(sareqId) {
    let token = localStorage.getItem('token');
    const headers = new HttpHeaders({'Accept':'application/json','Authorization':token});
    let params = new HttpParams();
    params = params.append("token", token);
    var file,fileURL,contentType;

    this.http.get(BackendUrl + "/sareq/" + sareqId + "/StampedsdsProductItem", {headers: headers, responseType: "arraybuffer"})
      .pipe(take(1)).subscribe({next: response => {
        if(response==null||response.byteLength==0){
          this.getDataSheetUpdated.next(null);
        } else {
          contentType = 'application/pdf';
          file = new Blob([response], { type: contentType });
          fileURL = URL.createObjectURL(file);
          this.getDataSheetUpdated.next(fileURL);
        }
      },
      error: error => {
        if (error.status === 401)
        {
          this.authService.logout();
        }
        this.getDataSheetUpdated.next(null);
      }
    });
  }

  getProductSheetAsTrustedResourceUrl(sareqId) {
    let token = localStorage.getItem('token');
    const headers = new HttpHeaders({'Accept':'application/json','Authorization':token});
    let params = new HttpParams();
    params = params.append("token", token);
    var file,fileURL,contentType;

    this.http.get(BackendUrl + "/sareq/" + sareqId + "/productsheet", {headers: headers, responseType: "arraybuffer"})
      .pipe(take(1)).subscribe({next: response => {
        if(response==null||response.byteLength==0){
          this.getDataSheetUpdated.next(null);
        } else {
          contentType = 'application/pdf';
          file = new Blob([response], { type: contentType });
          fileURL = URL.createObjectURL(file);
          this.getDataSheetUpdated.next(fileURL);
        }
      },
      error: error => {
        if (error.status === 401)
        {
          this.authService.logout();
        }
        this.getDataSheetUpdated.next(null);
      }
    });
  }

  getPictureAsTrustedResourceUrl(sareqId) {
    let token = localStorage.getItem('token');
    const headers = new HttpHeaders({'Accept':'application/json','Authorization':token});
    let params = new HttpParams();
    params = params.append("token", token);
    var file,fileURL,contentType;

    this.http.get(BackendUrl + "/sareq/" + sareqId + "/picture", {headers: headers, responseType: "blob"})
      .pipe(take(1)).subscribe({next: response => {
        file = new Blob([response], {type: 'application/image'});
        if (file.size !== 0)
        {
          const unsafeImg = URL.createObjectURL(file);
          var image = this.sanitizer.bypassSecurityTrustUrl(unsafeImg);
          this.getProductPictureDataUpdated.next(image);
        }
      },
      error: error => {
        if (error.status === 401)
        {
          this.authService.logout();
        }
        this.getProductPictureDataUpdated.next(null);
      }
    });
  }

  getLogoAsTrustedResourceUrl(sareqId) {
    let token = localStorage.getItem('token');
    const headers = new HttpHeaders({'Accept':'application/json','Authorization':token});
    let params = new HttpParams();
    params = params.append("token", token);
    var file,fileURL,contentType;

    this.http.get(BackendUrl + "/sareq/" + sareqId + "/logo", {headers: headers, responseType: "arraybuffer"})
      .pipe(take(1)).subscribe({next: response => {
        file = new Blob([response], {type: 'image/jpeg'});
        if (file.size !== 0)
        {
          fileURL = URL.createObjectURL(file);
          this.getLogoUpdated.next(fileURL);
        }
      },
      error: error => {
        this.getLogoUpdated.next(null);
      }
    });
  }

  getTransportInfoAsTrustedUrl(sareqId) {
    let token = localStorage.getItem('token');
    const headers = new HttpHeaders({'Accept':'application/json','Authorization':token});
    let params = new HttpParams();
    params = params.append("token", token);
    var file,fileURL,contentType;
    this.http.get(BackendUrl + "/sareq/" + sareqId + "/sdsTransportInfo2", {headers: headers, responseType: "arraybuffer"})
    .pipe(take(1)).subscribe({next: response => {
      if(response==null||response.byteLength==0){
        this.getDataSheetUpdated.next(null);
      } else {
        contentType = 'application/pdf';
        file = new Blob([response], { type: contentType });
        fileURL = URL.createObjectURL(file);
        this.getDataSheetUpdated.next(fileURL);
      }
    },
    error: error => {
      if (error.status === 401)
      {
        this.authService.logout();
      }
      this.getDataSheetUpdated.next(null);
    }
    });
  }

  getOtherAvailableLangs(productId) {
    let token = localStorage.getItem('token');
    const headers = new HttpHeaders({'Accept':'application/json','Authorization':token});
    let params = new HttpParams();
    params = params.append("token", token);
    var file,fileURL,contentType;
    this.http.get(BackendUrl + "/organisations/products/lang/" + productId, this.utilService.setHeadersAndParamsObject())
      .pipe(take(1)).subscribe({next: response => {
        this.getProductLangDataUpdated.next(response);
      },
      error: error => {
        if (error.status === 401)
        {
          this.authService.logout();
        }
        this.getProductLangDataUpdated.next(null);
      }
    });
  }

  AllWithSuborganisationsLessInformationAndStamped(orgId) {

    let token = localStorage.getItem('token');

    const headers = new HttpHeaders({'Accept':'application/json','Authorization':token});

    this.http.get(BackendUrl + '/organisations/' + orgId + '/products/subForUIStamped',{headers: headers}).pipe(take(1)).subscribe({next: response => {

        this.getProductDataUpdated.next(response);
      },
      error: error => {
        if (error.status === 401)
        {
          this.authService.logout();
        }
        this.getProductDataUpdated.next(null);
      }
    });
  }

  AllWithSuborganisationsLessInformation(orgId) {

    let token = localStorage.getItem('token');

    const headers = new HttpHeaders({'Accept':'application/json','Authorization':token});

    this.http.get(BackendUrl + '/organisations/' + orgId + '/products/subForUI',{headers: headers}).pipe(take(1)).subscribe({next: response => {

        this.productConversionsService.convertPictogramsOnProductArray(response);
        this.getAllProductDataUpdated.next(response);
      },
      error: error => {
        if (error.status === 401)
        {
          this.authService.logout();
        }
        this.getAllProductDataUpdated.next(null);
      }
    });
  }

  GetL(info) {
    let token = localStorage.getItem('token');
    const headers = new HttpHeaders({'Accept':'application/json','Authorization':token});
    let params = new HttpParams();
    params = params.append("token", token);
    let productId=info.productId;
    let lang=info.lang;
    this.http.get(BackendUrl + "/organisations/products/lang/"+productId+"/"+lang+"", {headers: headers})
      .pipe(take(1)).subscribe({next: response => {
        this.getProductDataUpdated.next(response);
      },
      error: error => {
        if (error.status === 401)
        {
          this.authService.logout();
        }
        this.getProductDataUpdated.next(null);
      }
    });
  }

  getRestriktionList(orgId) {
    let token = localStorage.getItem('token');

    const headers = new HttpHeaders({'Accept':'application/json','Authorization':token});

    this.http.get(BackendUrl + "/organisations/" + orgId + "/getRestriktionList/", {headers: headers}).pipe(take(1)).
      subscribe({next: response => {
        this.getProductRestDataUpdated.next(response);
      },
      error: error => {
        if (error.status === 401)
        {
          this.authService.logout();
        }
        this.getProductRestDataUpdated.next(null);
      }
    });
  }

  getHistoryForProducts(orgId, labels, year, productgroup) {
    let token = localStorage.getItem('token');

    const headers = new HttpHeaders({'Accept':'application/json','Authorization':token});
    let params = new HttpParams();
    params = params.append("year", year);
    params = params.append("productgroup", productgroup);

    this.http.get(BackendUrl + "/organisations/" + orgId + "/products/history/" + labels, {headers: headers, params: params}).pipe(take(1)).
      subscribe({next: response => {
        this.getProducthistoryDataUpdated.next(response);
      },
      error: error => {
        if (error.status === 401)
        {
          this.authService.logout();
        }
        this.getProducthistoryDataUpdated.next(null);
      }
    });
  }

  AllWithSuborganisationsMoreInformation(orgId) {
    let token = localStorage.getItem('token');

    const headers = new HttpHeaders({'Accept':'application/json','Authorization':token});

    this.http.get(BackendUrl + "/organisations/" + orgId + "/products/subMoreInformation", {headers: headers}).pipe(take(1)).
      subscribe({next: response => {

        this.productConversionsService.convertPictogramsOnProductArray(response);
        this.productConversionsService.convertFootprintOnProductArray(response);
        this.productConversionsService.convertIdOnProductArray(response);
        this.productConversionsService.convertClassificationOnProductArray(response);
        this.productConversionsService.convertProtectiveGearImagesOnProductArray(response);
        this.getProductsAllSupUpdated.next(response);
      },
      error: error => {
        if (error.status === 401)
        {
          this.authService.logout();
        }
        this.getProductsAllSupUpdated.next(null);
      }
    });
  }

  AllWithSuborganisationsMoreInformationTop(orgId) {
    let token = localStorage.getItem('token');

    const headers = new HttpHeaders({'Accept':'application/json','Authorization':token});

    this.http.get(BackendUrl + "/organisations/" + orgId + "/products/subMoreInformation", {headers: headers}).pipe(take(1)).
      subscribe({next: response => {

        this.productConversionsService.convertPictogramsOnProductArray(response);
        this.productConversionsService.convertFootprintOnProductArray(response);
        this.productConversionsService.convertIdOnProductArray(response);
        this.productConversionsService.convertClassificationOnProductArray(response);
        this.productConversionsService.convertProtectiveGearImagesOnProductArray(response);
        this.getProductsAllSupTopUpdated.next(response);
      },
      error: error => {
        if (error.status === 401)
        {
          this.authService.logout();
        }
        this.getProductsAllSupTopUpdated.next(null);
      }
    });
  }

  getDepartmentproductCount(orgId) {
    let token = localStorage.getItem('token');

    const headers = new HttpHeaders({'Accept':'application/json','Authorization':token});

    this.http.get(BackendUrl + "/organisations/" + orgId + "/products/subMoreInformation", {headers: headers}).pipe(take(1)).
      subscribe({next: response => {

        this.getProductsCountUpdated.next(response);
      },
      error: error => {
        if (error.status === 401)
        {
          this.authService.logout();
        }
        this.getProductsCountUpdated.next(null);
      }
    });
  }

  AllWithSuborganisationsMoreInformationStamped(orgId) {
    let token = localStorage.getItem('token');

    const headers = new HttpHeaders({'Accept':'application/json','Authorization':token});

    this.http.get(BackendUrl + "/organisations/" + orgId + "/products/subMoreInformationStamped", {headers: headers}).pipe(take(1)).
      subscribe({next: response => {

        this.productConversionsService.convertPictogramsOnProductArray(response);
        this.productConversionsService.convertFootprintOnProductArray(response);
        this.productConversionsService.convertIdOnProductArray(response);
        this.productConversionsService.convertClassificationOnProductArray(response);
        this.productConversionsService.convertProtectiveGearImagesOnProductArray(response);
        this.getProductsAllSupUpdated.next(response);
      },
      error: error => {
        if (error.status === 401)
        {
          this.authService.logout();
        }
        this.getProductsAllSupUpdated.next(null);
      }
    });
  }

  AllWithSuborganisationsMoreInformationStampedTop(orgId) {
    let token = localStorage.getItem('token');

    const headers = new HttpHeaders({'Accept':'application/json','Authorization':token});

    this.http.get(BackendUrl + "/organisations/" + orgId + "/products/subMoreInformationStamped", {headers: headers}).pipe(take(1)).
      subscribe({next: response => {

        this.productConversionsService.convertPictogramsOnProductArray(response);
        this.productConversionsService.convertFootprintOnProductArray(response);
        this.productConversionsService.convertIdOnProductArray(response);
        this.productConversionsService.convertClassificationOnProductArray(response);
        this.productConversionsService.convertProtectiveGearImagesOnProductArray(response);
        this.getProductsAllSupTopUpdated.next(response);
      },
      error: error => {
        if (error.status === 401)
        {
          this.authService.logout();
        }
        this.getProductsAllSupTopUpdated.next(null);
      }
    });
  }

  AllMoreInformationStamped(orgId) {
    let token = localStorage.getItem('token');

    const headers = new HttpHeaders({'Accept':'application/json','Authorization':token});

    this.http.get(BackendUrl + "/organisations/" + orgId + "/products/moreStamped", {headers: headers}).pipe(take(1)).
      subscribe({next: response => {

        this.productConversionsService.convertPictogramsOnProductArray(response);
        this.productConversionsService.convertFootprintOnProductArray(response);
        this.productConversionsService.convertIdOnProductArray(response);
        this.productConversionsService.convertClassificationOnProductArray(response);
        this.productConversionsService.convertProtectiveGearImagesOnProductArray(response);
        this.getProductsAllSupUpdated.next(response);
      },
      error: error => {
        if (error.status === 401)
        {
          this.authService.logout();
        }
        this.getProductsAllSupUpdated.next(null);
      }
    });
  }

  AllMoreInformation(orgId) {
    let token = localStorage.getItem('token');

    const headers = new HttpHeaders({'Accept':'application/json','Authorization':token});

    this.http.get(BackendUrl + "/organisations/" + orgId + "/products/more", {headers: headers}).pipe(take(1)).
      subscribe({next: response => {

        this.productConversionsService.convertPictogramsOnProductArray(response);
        this.productConversionsService.convertFootprintOnProductArray(response);
        this.productConversionsService.convertIdOnProductArray(response);
        this.productConversionsService.convertClassificationOnProductArray(response);
        this.productConversionsService.convertProtectiveGearImagesOnProductArray(response);
        this.getProductsAllSupUpdated.next(response);
      },
      error: error => {
        if (error.status === 401)
        {
          this.authService.logout();
        }
        this.getProductsAllSupUpdated.next(null);
      }
    });
  }

  /* As this is about exposure list, also deleted items are included */
  AllMoreInformationWithDeleted(orgId) {
    let token = localStorage.getItem('token');

    const headers = new HttpHeaders({'Accept':'application/json','Authorization':token});

    this.http.get(BackendUrl + "/organisations/" + orgId + "/products/morewithdeleted", {headers: headers}).pipe(take(1)).
      subscribe({next: response => {

        this.productConversionsService.convertPictogramsOnProductArray(response);
        this.productConversionsService.convertFootprintOnProductArray(response);
        this.productConversionsService.convertIdOnProductArray(response);
        this.productConversionsService.convertClassificationOnProductArray(response);
        this.productConversionsService.convertProtectiveGearImagesOnProductArray(response);
        this.getProductsAllSupUpdated.next(response);
      },
      error: error => {
        if (error.status === 401)
        {
          this.authService.logout();
        }
        this.getProductsAllSupUpdated.next(null);
      }
    });
  }

  /* Get only the deleted products for the given departments.
   * departmentIds: array of department ids to query (caller decides whether to
   * include subdepartments or just the single selected department). */
  /** Restore archived row from Deleted_Organisations_Products into Organisations_Products. */
  restoreDeletedProductToDepartment(
    departmentId: string | number,
    counterId: string | number,
  ): void {
    if (departmentId == null || counterId == null) {
      this.getProductDataUpdated.next(null);
      return;
    }

    const token = localStorage.getItem('token');
    const headers = new HttpHeaders({ Accept: 'application/json', Authorization: token });

    this.http
      .post(
        BackendUrl +
          '/organisations/' +
          departmentId +
          '/deletedProducts/' +
          counterId +
          '/restore',
        {},
        { headers },
      )
      .pipe(take(1))
      .subscribe({
        next: (response) => {
          if (response && typeof response === 'object' && !Array.isArray(response)) {
            this.productConversionsService.convertFootprintOnProduct(response);
            this.productConversionsService.convertIdOnProduct(response);
          }
          this.getProductDataUpdated.next(response);
        },
        error: (error) => {
          if (error.status === 401) {
            this.authService.logout();
          }
          this.getProductDataUpdated.next(null);
        },
      });
  }

  /** Update editable columns on Deleted_Organisations_Products (by counter_id). */
  updateDeletedOrganisationsProduct(
    departmentId: string | number,
    counterId: string | number,
    product: Record<string, unknown>,
  ): void {
    const token = localStorage.getItem('token');
    const headers = new HttpHeaders({ Accept: 'application/json', Authorization: token });

    const unit = product['unit'];
    const group = product['group'];
    const info = {
      amount: product['amount'],
      annual_consumption: product['annual_consumption'],
      maximum_amount: product['maximum_amount'],
      unit: _.isObject(unit) ? (unit as { id?: string }).id : unit,
      group_id: _.isObject(group) ? (group as { id?: string | number }).id : product['group_id'],
      department_info: product['department_info'] ?? '',
      footprint_water: product['o_footprint_water'] ? 1 : 0,
      footprint_air: product['o_footprint_air'] ? 1 : 0,
      footprint_product: product['o_footprint_product'] ? 1 : 0,
      footprint_waste: product['o_footprint_waste'] ? 1 : 0,
      footprint_comment: product['o_footprint_comment'] ?? '',
    };

    this.http
      .put(
        BackendUrl +
          '/organisations/' +
          departmentId +
          '/deletedProducts/' +
          counterId,
        info,
        { headers },
      )
      .pipe(take(1))
      .subscribe({
        next: (response) => {
          if (Array.isArray(response)) {
            this.productConversionsService.convertPictogramsOnProductArray(response);
            this.productConversionsService.convertFootprintOnProductArray(response);
            this.productConversionsService.convertIdOnProductArray(response);
            this.productConversionsService.convertClassificationOnProductArray(response);
            this.productConversionsService.convertProtectiveGearImagesOnProductArray(response);
          } else if (response && typeof response === 'object') {
            this.productConversionsService.convertFootprintOnProduct(response);
            this.productConversionsService.convertIdOnProduct(response);
          }
          this.getProductDataUpdated.next(response);
        },
        error: (error) => {
          if (error.status === 401) {
            this.authService.logout();
          }
          this.getProductDataUpdated.next(null);
        },
      });
  }

  getDeletedProductsForCustomer(orgId, departmentIds: (string | number)[]) {
    let token = localStorage.getItem('token');

    const headers = new HttpHeaders({'Accept':'application/json','Authorization':token});

    this.http.post(BackendUrl + "/organisations/" + orgId + "/products/getDeletedProductsOfCustomer", { departmentIds }, {headers: headers}).pipe(take(1)).
      subscribe({next: response => {

        this.productConversionsService.convertPictogramsOnProductArray(response);
        this.productConversionsService.convertFootprintOnProductArray(response);
        this.productConversionsService.convertIdOnProductArray(response);
        this.productConversionsService.convertClassificationOnProductArray(response);
        this.productConversionsService.convertProtectiveGearImagesOnProductArray(response);
        this.getDeletedProductsForCustomerUpdated.next(response);
      },
      error: error => {
        if (error.status === 401)
        {
          this.authService.logout();
        }
        this.getDeletedProductsForCustomerUpdated.next(null);
      }
    });
  }

  checkForOtherLanguages(orgId, products) {
    let token = localStorage.getItem('token');

    const headers = new HttpHeaders({'Accept':'application/json','Authorization':token});

    this.http.post(BackendUrl + "/organisations/" + orgId + "/otherLanguage", products, {headers: headers}).pipe(take(1)).
      subscribe({next: response => {

        this.getProductDataUpdated.next(response);
      },
      error: error => {
        if (error.status === 401)
        {
          this.authService.logout();
        }
        this.getProductDataUpdated.next(null);
      }
    });
  }

  checkIfLrbOrArbExists(productId,orgId){
    let token = localStorage.getItem('token');
    const headers = new HttpHeaders({'Accept':'application/json','Authorization':token});
    this.http.get(BackendUrl + "/organisations/" + orgId + "/products/checkiflrborarbexists/" + productId, {headers: headers})
      .pipe(take(1)).subscribe({next: response => {
        this.getCheckProductDataUpdated.next(response);
      },
      error: error => {
        if (error.status === 401) {
             this.authService.logout();
        }
        this.getCheckProductDataUpdated.next(null);

      }
    });
  }

  getAllARBForProducts(productIds: string[], orgId: string, includeSubdepartments: boolean = false): Observable<any[]> {
    let token = localStorage.getItem('token');
    const headers = new HttpHeaders({ 'Accept': 'application/json', 'Authorization': token });
    return this.http.post<any[]>(
      BackendUrl + "/organisations/" + orgId + "/products/getAllARBForProducts",
      { productIds, includeSubdepartments },
      { headers }
    );
  }

  getExtSdsAsTrustedResourceUrl(sareqId) {

    var file, fileURL;

    let token = localStorage.getItem('token');

    const headers = new HttpHeaders({'Accept':'application/json','Authorization':token});

    this.http.get(BackendUrl + "/sareq/" + sareqId + "/extsds", {headers: headers, responseType: "arraybuffer"}).pipe(take(1)).
      subscribe({next: response => {
        if(response==null||response.byteLength==0){
          this.getExtSdsDataUpdated.next(null);
        } else {
          var file = new Blob([response], {type: 'application/pdf'});
          var fileURL = URL.createObjectURL(file);
          this.getExtSdsDataUpdated.next(fileURL);
        }
      },
      error: error => {
        if (error.status === 401)
        {
          this.authService.logout();
        }
        this.getExtSdsDataUpdated.next(null);
      }
    });
  }

  getHPhrases(orgId, sareqProduct) {
    let token = localStorage.getItem('token');

    const headers = new HttpHeaders({'Accept':'application/json','Authorization':token});

    this.http.post(BackendUrl + "/organisations/" + orgId + "/getHPhrases/", sareqProduct, {headers: headers}).pipe(take(1)).
      subscribe({next: response => {

        this.getProductDataUpdated.next(response);
      },
      error: error => {
        if (error.status === 401)
        {
          this.authService.logout();
        }
        this.getProductDataUpdated.next(null);
      }
    });
  }

  getPPhrases(orgId, sareqProducts) {
    let token = localStorage.getItem('token');

    const headers = new HttpHeaders({'Accept':'application/json','Authorization':token});

    this.http.post(BackendUrl + "/organisations/" + orgId + "/getPPhrases/", sareqProducts, {headers: headers}).pipe(take(1)).
      subscribe({next: response => {

        this.getProductPphraseDataUpdated.next(response);
      },
      error: error => {
        if (error.status === 401)
        {
          this.authService.logout();
        }
        this.getProductPphraseDataUpdated.next(null);
      }
    });
  }

  getCPhrases(orgId, sareqProduct) {
    let token = localStorage.getItem('token');
    const headers = new HttpHeaders({'Accept':'application/json','Authorization':token});
    this.http.post(BackendUrl + "/organisations/" + orgId + "/getCPhrases/", sareqProduct, {headers: headers}).pipe(take(1)).
      subscribe({next: response => {
        this.getProductCphraseDataUpdated.next(response);
      },
      error: error => {
        if (error.status === 401)
        {
          this.authService.logout();
        }
        this.getProductCphraseDataUpdated.next(null);
      }
    });
  }

  getCas(orgId, sareqProducts) {
    let token = localStorage.getItem('token');

    const headers = new HttpHeaders({'Accept':'application/json','Authorization':token});

    this.http.post(BackendUrl + "/organisations/" + orgId + "/getCas/", sareqProducts, {headers: headers}).pipe(take(1)).
      subscribe({next: response => {

        this.getProductCasDataUpdated.next(response);
      },
      error: error => {
        if (error.status === 401)
        {
          this.authService.logout();
        }
        this.getProductCasDataUpdated.next(null);
      }
    });
  }

  getSubstanceGroups(orgId, sareqProducts) {
    let token = localStorage.getItem('token');

    const headers = new HttpHeaders({'Accept':'application/json','Authorization':token});

    this.http.post(BackendUrl + "/organisations/" + orgId + "/getSubstanceGroups/", sareqProducts, {headers: headers}).pipe(take(1)).
      subscribe({next: response => {

        this.getProductSubstanceGroupsDataUpdated.next(response);
      },
      error: error => {
        if (error.status === 401)
        {
          this.authService.logout();
        }
        this.getProductSubstanceGroupsDataUpdated.next(null);
      }
    });
  }

  getHPhrasesSeveralArrays(orgId, sareqProduct) {
    let token = localStorage.getItem('token');

    const headers = new HttpHeaders({'Accept':'application/json','Authorization':token});

    this.http.post(BackendUrl + "/organisations/" + orgId + "/products/getHPhrasesSeveralArrays/", sareqProduct, {headers: headers}).pipe(take(1)).
      subscribe({next: response => {

        this.getProductDataUpdated.next(response);
      },
      error: error => {
        if (error.status === 401)
        {
          this.authService.logout();
        }
        this.getProductDataUpdated.next(null);
      }
    });
  }

  getRestriktionListAllAdded(orgId) {

    var file, fileURL;

    let token = localStorage.getItem('token');

    const headers = new HttpHeaders({'Accept':'application/json','Authorization':token});

    this.http.get(BackendUrl + "/organisations/" + orgId + "/getRestriktionListAllAdded/", {headers: headers}).pipe(take(1)).
      subscribe({next: response => {

        this.getProductRestrictionDataUpdated.next(response);
      },
      error: error => {
        if (error.status === 401)
        {
          this.authService.logout();
        }
        this.getProductRestrictionDataUpdated.next(null);
      }
    });
  }

  fetchInventoryTemplate(orgId) {

    let token = localStorage.getItem('token');

    const headers = new HttpHeaders({'Accept':'application/json','Authorization':token});

    this.http.get(BackendUrl + "/organisations/" + orgId + "/products/excel", {headers: headers, responseType: "arraybuffer"}).pipe(take(1)).
      subscribe({next: response => {

        var contentType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
        var file = new Blob([response], { type: contentType });
        var fileURL = URL.createObjectURL(file);
        this.getProductDataUpdated.next(fileURL);
      },
      error: error => {
        if (error.status === 401)
        {
          this.authService.logout();
        }
        this.getProductDataUpdated.next(null);
      }
    });
  }

  postInventoryList(orgId, file_id) {

    let token = localStorage.getItem('token');

    const headers = new HttpHeaders({'Accept':'application/json','Authorization':token});

    let params = new HttpParams();
    params = params.append("data", file_id);

    this.http.post<any>(BackendUrl + "/organisations/" + orgId + "/products/excel", null, {headers: headers, params: params}).pipe(take(1)).
      subscribe({next: response => {

        this.getProductDataUpdated.next(response);
      },
      error: error => {
        if (error.status === 401)
        {
          this.authService.logout();
        }
        this.getProductDataUpdated.next(null);
      }
    });
  }

  addSareqProductToDepartment(orgId, sareqProduct) {

    let token = localStorage.getItem('token');

    const headers = new HttpHeaders({'Accept':'application/json','Authorization':token});
    const unit = sareqProduct.unit;
    const group = sareqProduct.group;
    var info: Record<string, unknown> = {
      product_id: sareqProduct.id,
      amount: sareqProduct.amount,
      annual_consumption: sareqProduct.annual_consumption,
      maximum_amount: sareqProduct.maximum_amount,
      unit: _.isObject(unit) ? unit.id : (unit != null && unit !== '' ? unit : null),
      group_id: _.isObject(group) ? group.id : (sareqProduct.group_id != null && sareqProduct.group_id !== '' ? sareqProduct.group_id : null),
      category_ids: Array.isArray(sareqProduct.category_ids)
        ? sareqProduct.category_ids
        : (Array.isArray(sareqProduct.categories)
          ? sareqProduct.categories.map((c: any) => c?.id).filter((id: any) => id != null)
          : []),
      own_article_number: sareqProduct.own_article_number ? sareqProduct.own_article_number:"",
      new_own_article_number: sareqProduct.new_own_article_number ? sareqProduct.new_own_article_number:""
    };

    if (sareqProduct.department_info != null) {
      info.department_info = sareqProduct.department_info;
    }
    if (sareqProduct.o_footprint_water != null || sareqProduct.footprint_water != null) {
      info.footprint_water = (sareqProduct.o_footprint_water ?? sareqProduct.footprint_water) ? 1 : 0;
    }
    if (sareqProduct.o_footprint_air != null || sareqProduct.footprint_air != null) {
      info.footprint_air = (sareqProduct.o_footprint_air ?? sareqProduct.footprint_air) ? 1 : 0;
    }
    if (sareqProduct.o_footprint_product != null || sareqProduct.footprint_product != null) {
      info.footprint_product = (sareqProduct.o_footprint_product ?? sareqProduct.footprint_product) ? 1 : 0;
    }
    if (sareqProduct.o_footprint_waste != null || sareqProduct.footprint_waste != null) {
      info.footprint_waste = (sareqProduct.o_footprint_waste ?? sareqProduct.footprint_waste) ? 1 : 0;
    }
    const footprintComment = sareqProduct.o_footprint_comment ?? sareqProduct.footprint_comment;
    if (footprintComment != null) {
      info.footprint_comment = footprintComment;
    }

    this.http.post<any>(BackendUrl + "/organisations/" + orgId + "/products", info, {headers: headers})
      .pipe(take(1)).subscribe({next: response => {

        this.getProductDataUpdated.next(response);
        this.notifyProductListChanged();
      },
      error: error => {
        if (error.status === 401)
        {
          this.authService.logout();
        }
        this.getProductDataUpdated.next(null);
      }
    });
  }

  /**
   * ARB copy: add product to a department. Sends o_footprint_* (backend create keys),
   * optional replaced_by; omit department_info to leave it empty on the target.
   */
  addProductToDepartmentForArbCopy$(orgId, sareqProduct): Observable<any> {
    const token = localStorage.getItem('token');
    const headers = new HttpHeaders({ Accept: 'application/json', Authorization: token });
    const unit = sareqProduct.unit;
    const group = sareqProduct.group;
    const info: Record<string, unknown> = {
      product_id: sareqProduct.id,
      amount: sareqProduct.amount,
      annual_consumption: sareqProduct.annual_consumption,
      maximum_amount: sareqProduct.maximum_amount,
      unit: _.isObject(unit) ? unit.id : (unit != null && unit !== '' ? unit : null),
      group_id: _.isObject(group) ? group.id : (sareqProduct.group_id != null && sareqProduct.group_id !== '' ? sareqProduct.group_id : null),
      category_ids: Array.isArray(sareqProduct.category_ids)
        ? sareqProduct.category_ids
        : (Array.isArray(sareqProduct.categories)
          ? sareqProduct.categories.map((c: any) => c?.id).filter((id: any) => id != null)
          : []),
      own_article_number: sareqProduct.own_article_number ? sareqProduct.own_article_number : '',
      new_own_article_number: sareqProduct.new_own_article_number ? sareqProduct.new_own_article_number : '',
      // Backend create opts in to writing footprint_* on Organisations_Products when true
      copy_with_footprint: true,
    };

    if (sareqProduct.department_info != null) {
      info.department_info = sareqProduct.department_info;
    }
    if (sareqProduct.replaced_by != null && sareqProduct.replaced_by !== '') {
      info.replaced_by = sareqProduct.replaced_by;
    }
    if (sareqProduct.o_footprint_water != null || sareqProduct.footprint_water != null) {
      info.o_footprint_water = !!(sareqProduct.o_footprint_water ?? sareqProduct.footprint_water);
    }
    if (sareqProduct.o_footprint_air != null || sareqProduct.footprint_air != null) {
      info.o_footprint_air = !!(sareqProduct.o_footprint_air ?? sareqProduct.footprint_air);
    }
    if (sareqProduct.o_footprint_product != null || sareqProduct.footprint_product != null) {
      info.o_footprint_product = !!(sareqProduct.o_footprint_product ?? sareqProduct.footprint_product);
    }
    if (sareqProduct.o_footprint_waste != null || sareqProduct.footprint_waste != null) {
      info.o_footprint_waste = !!(sareqProduct.o_footprint_waste ?? sareqProduct.footprint_waste);
    }
    const footprintComment = sareqProduct.o_footprint_comment ?? sareqProduct.footprint_comment;
    if (footprintComment != null) {
      info.o_footprint_comment = footprintComment;
    }

    return this.http.post<any>(BackendUrl + '/organisations/' + orgId + '/products', info, { headers }).pipe(
      take(1),
      tap((response) => {
        this.getProductDataUpdated.next(response);
        this.notifyProductListChanged();
      }),
      catchError((error) => {
        if (error?.status === 401) {
          this.authService.logout();
        }
        this.getProductDataUpdated.next(null);
        return of(null);
      })
    );
  }

  getProductIdFromName(name, sname) {

    let token = localStorage.getItem('token');

    const headers = new HttpHeaders({'Accept':'application/json','Authorization':token});

    let params = new HttpParams();
    params = params.append("product_name", name.replace('+','plussign'));
    params = params.append("supplier_name", sname.replace('+','plussign'));

    this.http.get<any>(BackendUrl + "/sareq/get_sareq_id_by_product_and_supplier", {headers: headers, params: params}).pipe(take(1)).
      subscribe({next: response => {

        this.getProductDataUpdated.next(response);
      },
      error: error => {
        if (error.status === 401)
        {
          this.authService.logout();
        }
        this.getProductDataUpdated.next(null);
      }
    });
  }

  /**
   * Observable Sareq id lookup (same request as getProductIdFromName) — use for async/await;
   * errors emit null to getProductDataUpdated like the void API methods.
   */
  getSareqIdByProductAndSupplier$(
    name: string,
    supplier: string
  ): Observable<any> {
    const token = localStorage.getItem('token');
    const headers = new HttpHeaders({ Accept: 'application/json', Authorization: token });
    let params = new HttpParams();
    params = params.append('product_name', name.replace('+', 'plussign'));
    params = params.append('supplier_name', supplier.replace('+', 'plussign'));
    return this.http
      .get<any>(BackendUrl + '/sareq/get_sareq_id_by_product_and_supplier', { headers, params })
      .pipe(
        take(1),
        tap((response) => this.getProductDataUpdated.next(response)),
        catchError((error) => {
          if (error?.status === 401) {
            this.authService.logout();
          }
          this.getProductDataUpdated.next(null);
          return of(null);
        })
      );
  }

  postProductInOrg(orgId, product) {
    let token = localStorage.getItem('token');

    const headers = new HttpHeaders({'Accept':'application/json','Authorization':token});
    product.name=product.name.replace('+','plussign');
    product.manufacturer=product.manufacturer.replace('+','plussign');

    this.http.post<any>(BackendUrl + "/organisations/" + orgId + "/products/", product, {headers: headers}).pipe(take(1)).
      subscribe({next: response => {

        this.getProductDataUpdated.next(response);
        this.notifyProductListChanged();
      },
      error: error => {
        if (error.status === 401)
        {
          this.authService.logout();
        }
        this.getProductDataUpdated.next(null);
      }
    });
  }

  /**
   * Observable add product to org (same as postProductInOrg) — suitable for forkJoin/await;
   * mutates name/manufacturer on product like postProductInOrg.
   */
  postProductInOrg$(
    orgId: any,
    product: any
  ): Observable<any> {
    const token = localStorage.getItem('token');
    const headers = new HttpHeaders({ Accept: 'application/json', Authorization: token });
    product.name = product.name.replace('+', 'plussign');
    product.manufacturer = product.manufacturer.replace('+', 'plussign');
    return this.http
      .post<any>(BackendUrl + '/organisations/' + orgId + '/products/', product, { headers })
      .pipe(
        take(1),
        tap((response) => {
          this.getProductDataUpdated.next(response);
          this.notifyProductListChanged();
        }),
        catchError((error) => {
          if (error?.status === 401) {
            this.authService.logout();
          }
          this.getProductDataUpdated.next(null);
          return of(null);
        })
      );
  }

  getSingleProduct(orgId, productId) {

    let token = localStorage.getItem('token');

    const headers = new HttpHeaders({'Accept':'application/json','Authorization':token});

    this.http.get<any>(BackendUrl + "/organisations/" + orgId + "/products/" + productId, {headers: headers}).pipe(take(1)).
      subscribe({next: response => {

        response = response[0];
        this.productConversionsService.convertPictogramsOnProduct(response);
        this.productConversionsService.convertPhrasesOnProduct(response);
        this.productConversionsService.convertFootprintOnProduct(response);
        this.productConversionsService.convertICEOnProduct(response);
        this.productConversionsService.convertProtectionOnProduct(response);
        this.productConversionsService.setProductRiskLists(response);
        this.productConversionsService.convertIdOnProduct(response);
        this.productConversionsService.convertClassificationOnProduct(response);
        this.productConversionsService.convertProtectiveGearImagesToProduct(response);
        this.getProductSingleDataUpdated.next(response);
      },
      error: error => {
        if (error.status === 401)
        {
          this.authService.logout();
        }
        this.getProductSingleDataUpdated.next(null);
      }
    });
  }

  /** Single-product fetch without notifying getProductSingleDataListener. */
  getSingleProductSilent$(orgId, productId): Observable<any> {
    if (orgId == null || productId == null) {
      return of(null);
    }

    const token = localStorage.getItem('token');
    const headers = new HttpHeaders({ Accept: 'application/json', Authorization: token });

    return this.http.get<any>(BackendUrl + '/organisations/' + orgId + '/products/' + productId, { headers }).pipe(
      take(1),
      map((response) => {
        const product = Array.isArray(response) ? response[0] : response;
        if (!product) {
          return null;
        }
        this.productConversionsService.convertPictogramsOnProduct(product);
        this.productConversionsService.convertPhrasesOnProduct(product);
        this.productConversionsService.convertFootprintOnProduct(product);
        this.productConversionsService.convertICEOnProduct(product);
        this.productConversionsService.convertProtectionOnProduct(product);
        this.productConversionsService.setProductRiskLists(product);
        this.productConversionsService.convertIdOnProduct(product);
        this.productConversionsService.convertClassificationOnProduct(product);
        this.productConversionsService.convertProtectiveGearImagesToProduct(product);
        return product;
      }),
      catchError((error) => {
        if (error?.status === 401) {
          this.authService.logout();
        }
        return of(null);
      })
    );
  }

  /** ARB copy: observable single-product fetch (same conversions as getSingleProduct). */
  getSingleProductForArbCopy$(orgId, productId): Observable<any> {
    return this.getSingleProductSilent$(orgId, productId).pipe(
      tap((product) => this.getProductSingleDataUpdated.next(product))
    );
  }

  AllWithSuborganisations() {

    let token = localStorage.getItem('token');

    if (localStorage.getItem('selectedDepartment', ) != null )
    {
      var orgId = JSON.parse(localStorage.getItem('selectedDepartment', )).id;
      if (orgId == null)
      {
        this.authService.logout();
      }

      const headers = new HttpHeaders({'Accept':'application/json','Authorization':token});

      this.http.get<any>(BackendUrl + "/organisations/" + orgId + "/products/sub", {headers: headers}).pipe(take(1)).
        subscribe({next: response => {

          this.getProductDataUpdated.next(response);
        },
        error: error => {
          if (error.status === 401)
          {
            this.authService.logout();
          }
          this.getProductDataUpdated.next(null);
        }
      });
    }
  }

  getAllProducts() {

    let token = localStorage.getItem('token');

    if (localStorage.getItem('selectedDepartment', ) != null )
    {
      var orgId = JSON.parse(localStorage.getItem('selectedDepartment', )).id;
      if (orgId == null)
      {
        this.authService.logout();
      }

      const headers = new HttpHeaders({'Accept':'application/json','Authorization':token});

      this.http.get<any>(BackendUrl + "/organisations/" + orgId + "/products", {headers: headers}).pipe(take(1)).
        subscribe({next: response => {

          this.getProductDataUpdated.next(response);
        },
        error: error => {
          if (error.status === 401)
          {
            this.authService.logout();
          }
          this.getProductDataUpdated.next(null);
        }
      });
    }
  }

  getDepartmentsWhereProductAppearsByProductId(productId, org) {

    if (org)
    {
      var departmentId = JSON.parse(localStorage.getItem('selectedOrganisation', )).id;
    }
    else
    {
      var departmentId = JSON.parse(localStorage.getItem('selectedDepartment', )).id;
    }

    if (departmentId == null) {
      this.authService.logout();
    }

    let token = localStorage.getItem('token');

    const headers = new HttpHeaders({'Accept':'application/json','Authorization':token});

    this.http.get<any>(BackendUrl + "/organisations/" + departmentId + "/products/" + productId + "/suborgs", {headers: headers}).pipe(take(1)).
      subscribe({next: response => {

        this.getProductDepartmentDataUpdated.next(response);
      },
      error: error => {
        if (error.status === 401)
        {
          this.authService.logout();
        }
        this.getProductDepartmentDataUpdated.next(null);
      }
    });
  }

  createTransportInfo(productId) {

    var file, fileURL;

    if (localStorage.getItem('selectedOrganisation', ) != null )
    {
      var departmentId = JSON.parse(localStorage.getItem('selectedOrganisation', )).id;
      if (departmentId == null)
      {
        this.authService.logout();
      }

      let token = localStorage.getItem('token');

      const headers = new HttpHeaders({'Accept':'application/json','Authorization':token});

      let usedLanguage = localStorage.getItem('usedLanguage');

      let params = new HttpParams();
      params = params.append("language", usedLanguage);

      this.http.get(BackendUrl + "/organisations/" + departmentId + "/products/" + productId + "/transport_info", {headers: headers, params: params, responseType:"arraybuffer"}).pipe(take(1)).
        subscribe({next: response => {

          var file = new Blob([response], {type: 'application/pdf'});
          var fileURL = URL.createObjectURL(file);
          this.getProductDataUpdated.next(fileURL);
        },
        error: error => {
          if (error.status === 401)
          {
            this.authService.logout();
          }
          this.getProductDataUpdated.next(null);
        }
      });
    }
  }

  createCargoDeclaration(productId, numberOfPackages, typeOfPackages, netWeight, volume, shipper, shipper2, shipper3, consignee1, consignee2, consignee3, environment, overpack, name = '', funktion = '', ...extraFields: any[]) {

    var file, fileURL;
    const ort = extraFields?.[0] ?? '';
    const datum = extraFields?.[1] ?? '';

    if (localStorage.getItem('selectedOrganisation', ) != null )
    {
      var departmentId = JSON.parse(localStorage.getItem('selectedOrganisation', )).id;
      if (departmentId == null)
      {
        this.authService.logout();
      }

      let token = localStorage.getItem('token');

      let usedLanguage = localStorage.getItem('usedLanguage');

      const headers = new HttpHeaders({'Accept':'application/json','Authorization':token});

      let params = new HttpParams();
      params = params.append("numberOfPackages", numberOfPackages||0);
      params = params.append("typeOfPackages", typeOfPackages||'');
      params = params.append("netWeight", netWeight||0);
      params = params.append("volume", volume||0);
      params = params.append("shipper", shipper||'');
      params = params.append("shipper2", shipper2||'');
      params = params.append("shipper3", shipper3||'');
      params = params.append("consignee1", consignee1||'');
      params = params.append("consignee2", consignee2||'');
      params = params.append("consignee3", consignee3||'');
      params = params.append("name", name||'');
      params = params.append("funktion", funktion||'');
      params = params.append("ort", ort||'');
      params = params.append("datum", datum||'');
      params = params.append("environment", environment);
      params = params.append("overpack", overpack);
      params = params.append("language", usedLanguage);

      this.http.get(BackendUrl + "/organisations/" + departmentId + "/products/" + productId + "/cargo_declaration", {headers: headers, params: params, responseType:"arraybuffer"}).pipe(take(1)).
        subscribe({next: response => {

          var file = new Blob([response], {type: 'application/pdf'});
          this.getProductCargoDataUpdated.next(file);
        },
        error: error => {
          if (error.status === 401)
          {
            this.authService.logout();
          }
          this.getProductCargoDataUpdated.next(null);
        }
      });
    }
  }

  createCargoDeclarationWithContactInfo(productId, numberOfPackages, typeOfPackages, netWeight, volume, shipper, shipper2, shipper3, consignee1, consignee2, consignee3, environment, overpack, name = '', funktion = '', ort = '', datum = '', additionalInfo = '') {
    var file, fileURL;

    if (localStorage.getItem('selectedOrganisation', ) != null )
    {
      var departmentId = JSON.parse(localStorage.getItem('selectedOrganisation', )).id;
      if (departmentId == null)
      {
        this.authService.logout();
      }

      let token = localStorage.getItem('token');
      let usedLanguage = localStorage.getItem('usedLanguage');
      const headers = new HttpHeaders({'Accept':'application/json','Authorization':token});

      let params = new HttpParams();
      params = params.append("numberOfPackages", numberOfPackages||0);
      params = params.append("typeOfPackages", typeOfPackages||'');
      params = params.append("netWeight", netWeight||0);
      params = params.append("volume", volume||0);
      params = params.append("shipper", shipper||'');
      params = params.append("shipper2", shipper2||'');
      params = params.append("shipper3", shipper3||'');
      params = params.append("consignee1", consignee1||'');
      params = params.append("consignee2", consignee2||'');
      params = params.append("consignee3", consignee3||'');
      params = params.append("name", name||'');
      params = params.append("funktion", funktion||'');
      params = params.append("ort", ort||'');
      params = params.append("datum", datum||'');
      params = params.append("environment", environment);
      params = params.append("overpack", overpack);
      params = params.append("language", usedLanguage);
      params = params.append("additionalInfo", additionalInfo||'');

      this.http.get(BackendUrl + "/organisations/" + departmentId + "/products/" + productId + "/cargo_declaration", {headers: headers, params: params, responseType:"arraybuffer"}).pipe(take(1)).
        subscribe({next: response => {
          var file = new Blob([response], {type: 'application/pdf'});
          this.getProductCargoDataUpdated.next(file);
        },
        error: error => {
          if (error.status === 401)
          {
            this.authService.logout();
          }
          this.getProductCargoDataUpdated.next(null);
        }
      });
    }
  }

  getSdsWithRiskIdAsTrustedResourceUrl(riskId) {

    let token = localStorage.getItem('token');

    const headers = new HttpHeaders({'Accept':'application/json','Authorization':token});

    this.http.get(BackendUrl + "/sareq/sds/" + riskId, {headers: headers, responseType: "arraybuffer"}).pipe(take(1)).
      subscribe({next: response => {

        var file = new Blob([response], {type: 'application/pdf'});
        var fileURL = URL.createObjectURL(file);
        this.getDataSheetUpdated.next(fileURL);
      },
      error: error => {
        if (error.status === 401)
        {
          this.authService.logout();
        }
        this.getDataSheetUpdated.next(null);
      }
    });
  }

  getGrbWithRiskIdAsTrustedResourceUrl(riskId) {

    let token = localStorage.getItem('token');

    const headers = new HttpHeaders({'Accept':'application/json','Authorization':token});

    this.http.get(BackendUrl + "/sareq/grb/" + riskId, {headers: headers, responseType: "arraybuffer"}).pipe(take(1)).
      subscribe({next: response => {

        var file = new Blob([response], {type: 'application/pdf'});
        var fileURL = URL.createObjectURL(file);
        this.getDataSheetUpdated.next(fileURL);
      },
      error: error => {
        if (error.status === 401)
        {
          this.authService.logout();
        }
        this.getDataSheetUpdated.next(null);
      }
    });
  }

  updateSingleProduct(product) {

    let token = localStorage.getItem('token');

    if (localStorage.getItem('selectedDepartment', ) != null )
    {
      var orgId = JSON.parse(localStorage.getItem('selectedDepartment', )).id;
      if (orgId == null)
      {
        this.authService.logout();
      }

      const headers = new HttpHeaders({'Accept':'application/json','Authorization':token});

      var info = {
        productId: product.id
      }

      this.http.put(BackendUrl + "/organisations/" + orgId + "/products/" + product.id, product, {headers: headers})
        .pipe(take(1)).subscribe({next: response => {

          this.getProductDataUpdated.next(response);
          this.notifyProductListChanged();
        },
        error: error => {
          if (error.status === 401)
          {
            this.authService.logout();
          }
          this.getProductDataUpdated.next(null);
        }
      });
    }
  }

  /**
   * Extend product save with department_info targets.
   * Backend is expected to apply department_info to department_info_org_ids (one/several/all).
   * Until then the PUT still updates the current organisation; extra fields are ignored safely.
   */
  updateSingleProductWithDepartmentInfoTargets(
    product: any,
    departmentInfoOrgIds: Array<string | number> | null | undefined
  ) {
    const targets = Array.isArray(departmentInfoOrgIds)
      ? departmentInfoOrgIds.map((id) => String(id)).filter(Boolean)
      : [];

    const payload = {
      ...product,
      department_info_org_ids: targets,
    };

    this.updateSingleProduct(payload);
  }

  /** PUT product on an explicit organisation id (for multi-dept frontend fan-out if needed). */
  updateSingleProductForOrg(orgId: string | number, product: any) {
    const token = localStorage.getItem('token');
    if (orgId == null) {
      this.getProductDataUpdated.next(null);
      return;
    }

    const headers = new HttpHeaders({ Accept: 'application/json', Authorization: token });
    this.http
      .put(BackendUrl + '/organisations/' + orgId + '/products/' + product.id, product, {
        headers,
      })
      .pipe(take(1))
      .subscribe({
        next: (response) => {
          this.getProductDataUpdated.next(response);
          this.notifyProductListChanged();
        },
        error: (error) => {
          if (error.status === 401) {
            this.authService.logout();
          }
          this.getProductDataUpdated.next(null);
        },
      });
  }

  removeSingleProduct(product) {

    let token = localStorage.getItem('token');

    if (localStorage.getItem('selectedDepartment', ) != null )
    {
      var orgId = JSON.parse(localStorage.getItem('selectedDepartment', )).id;
      if (orgId == null)
      {
        this.authService.logout();
      }

      const headers = new HttpHeaders({'Accept':'application/json','Authorization':token});

      let params = new HttpParams();
      params = product;

      this.http.delete<any>(BackendUrl + "/organisations/" + orgId + "/products/" + product.productId, {headers: headers, params:params}).pipe(take(1)).subscribe({next: response => {

          this.getProductDataUpdated.next(true);
          this.notifyProductListChanged();
        },
        error: error => {
          if (error.status === 401)
          {
            this.authService.logout();
          }
          this.getProductDataUpdated.next(true);
        }
      });
    }
  }

  AllWithSuborganisationsMoreInformationControlPanel(id)
  {
    let token = localStorage.getItem('token');
    const headers = new HttpHeaders({'Accept':'application/json','Authorization':token});
    let params = new HttpParams();
    params = params.append("orgid", id);
    this.http.get(BackendUrl + "/organisations/"+id+"/products/subMoreInformationControlPanel", {headers: headers})
    .pipe(take(1)).subscribe({next: response => {
      this.getProductDataUpdated.next(response);
    },
    error: error => {
      this.getProductDataUpdated.next(null);
    }

    })
  }

  checkForOtherLanguagesControlPanel(products)
  {
    if (localStorage.getItem('selectedOrganisation2', ) != null )
    {
      var departmentId = JSON.parse(localStorage.getItem('selectedOrganisation2', )).id;
      if (departmentId == null)
      {
        this.authService.logout();
      }

      let token = localStorage.getItem('token');
      const headers = new HttpHeaders({'Accept':'application/json','Authorization':token});
      this.http.post(BackendUrl + '/organisations/' + departmentId + "/otherLanguage", products, {headers: headers})
      .pipe(take(1)).subscribe({next: response => {
        if(response == undefined)
        {
          this.getProductDataUpdated.next(null);
        }else{
          this.getProductDataUpdated.next(response);
        }
      },
      error: error => {
        this.getProductDataUpdated.next(null);
      }

      })
    }
  }

  getDatasheetInfo(orgId)
  {
    var departmentId = orgId;
    let token = localStorage.getItem('token');
    const headers = new HttpHeaders({'Accept':'application/json','Authorization':token});
    this.http.get(BackendUrl + '/organisations/' + departmentId + '/getdatasheetinfo', {headers: headers})
    .pipe(take(1)).subscribe({next: response => {
      if(response == undefined)
      {
        this.getProductDataUpdated.next(null);
      }else{
        this.getProductDataUpdated.next(response);
      }
    },
    error: error => {
      this.getProductDataUpdated.next(null);
    }

    })
  }

  getMultipleSdsAsTrustedResourceUrlBySareqIdArray(sareqIdArray, date) {

    var i,
        query = {
          sareq_list: [],
          date : date
      };

    let token = localStorage.getItem('token');

    const headers = new HttpHeaders({'Accept':'application/json','Authorization':token});

    if (_.isArray(sareqIdArray)) {
      for (i = 0; i < sareqIdArray.length; i += 1) {
        query.sareq_list.push({sareq_id: sareqIdArray[i]});
      }

      this.http.post<any>(BackendUrl + "/sareq/multiple_sds", query, {headers: headers}).pipe(take(1)).
        subscribe({next: response => {

          this.getProductDataUpdated.next(response);
        },
        error: error => {
          if (error.status === 401)
          {
            this.authService.logout();
          }
          this.getProductDataUpdated.next(null);
        }
      });
    }
  }

  getMultipleSdsBySareqIdArray(fileId)
  {
    let token = localStorage.getItem('token');

    const headers = new HttpHeaders({'Accept':'application/json','Authorization':token});

    let params = new HttpParams();
    params = params.append("file_id", fileId);

    this.http.get(BackendUrl + "/sareq/multiple_sds", {headers: headers, params: params, responseType: "arraybuffer"})

      .pipe(take(1)).subscribe({next: response => {

        var file = new Blob([response], {type: 'application/pdf'});
        var fileURL = URL.createObjectURL(file);
        this.getProductDataUpdated.next(fileURL);
      },
      error: error => {
        this.getProductDataUpdated.next(null);
      }
    })
  }

  getMultipleGrbAsTrustedResourceUrlBySareqIdArray(sareqIdArray, date) {

    var i,
        query = {
          sareq_list: [],
          date : date
      };

    let token = localStorage.getItem('token');

    const headers = new HttpHeaders({'Accept':'application/json','Authorization':token});

    if (_.isArray(sareqIdArray)) {
      for (i = 0; i < sareqIdArray.length; i += 1) {
        query.sareq_list.push({sareq_id: sareqIdArray[i]});
      }

      this.http.post<any>(BackendUrl + "/sareq/multiple_grb", query, {headers: headers}).pipe(take(1)).
        subscribe({next: response => {
          this.getProductDataUpdated.next(response);
        },
        error: error => {
          if (error.status === 401)
          {
            this.authService.logout();
          }
          this.getProductDataUpdated.next(null);
        }
      });
    }
  }

  getMultipleGrbBySareqIdArray(fileId)
  {
    let token = localStorage.getItem('token');

    const headers = new HttpHeaders({'Accept':'application/json','Authorization':token});

    let params = new HttpParams();
    params = params.append("file_id", fileId);

    this.http.get(BackendUrl + "/sareq/multiple_grb", {headers: headers, params: params, responseType: "arraybuffer"})

      .pipe(take(1)).subscribe({next: response => {

        var file = new Blob([response], {type: 'application/pdf'});
        var fileURL = URL.createObjectURL(file);
        this.getProductDataUpdated.next(fileURL);
      },
      error: error => {
        this.getProductDataUpdated.next(null);
      }
    })
  }

  getDepartmentsOfProduct(organisationId, productId) {

    let token = localStorage.getItem('token');

    const headers = new HttpHeaders({'Accept':'application/json','Authorization':token});
    let params = new HttpParams();
    params = params.append("token", token);

    this.http.get(BackendUrl + "/organisations/" + organisationId + "/products/departments/" + productId, {headers: headers})
      .pipe(take(1)).subscribe({next: response => {
        this.getProductDataUpdated.next(response);
      },
      error: error => {
        if (error.status === 401)
        {
          this.authService.logout();
        }
        this.getProductDataUpdated.next(null);
      }
    });
  }

  deleteImportedProducts(year,orgid,orgname) {
    let token = localStorage.getItem('token');
    const headers = new HttpHeaders({'Accept':'application/json','Authorization':token});
    let params = new HttpParams();
    params = params.append("year",year);
    params = params.append("orgname", orgname);

    this.http.delete(BackendUrl + "/organisations/" + orgid + "/products/deleteimportedproducts/", {headers: headers, params: params})
      .pipe(take(1)).subscribe({next: response => {
        this.getProductDataUpdated.next(response);
        this.notifyProductListChanged();
      },
      error: error => {
        if (error.status === 401)
        {
          this.authService.logout();
        }
        this.getProductDataUpdated.next(null);
      }
    });
  }

  replaceDuplicate(oldProductId, newProductId, departments, keep, LRBInfo) {
    if (localStorage.getItem("selectedDepartment") != null) {
      var orgId = JSON.parse(localStorage.getItem("selectedDepartment")).id;
      if (orgId == null) {
        this.authService.logout();
      }
      var info = {
        "oldProductId":oldProductId,
        "newProductId": newProductId,
        "departments":departments,
        "keep":keep,
        "LRBInfo": LRBInfo ? LRBInfo : null
      };
    }
    let token = localStorage.getItem("token");
    const headers = new HttpHeaders({
      Accept: "application/json",
      Authorization: token,
    });
    this.http
      .put<any>(
        BackendUrl + "/organisations/" + orgId + "/replaceduplicate",
        info,
        { headers: headers }
      )
      .pipe(take(1))
      .subscribe({
        next: (response) => {
          this.getProductDataUpdated.next(response);
          this.notifyProductListChanged();
        },
        error: (error) => {
          if (error.status === 401) {
            this.authService.logout();
          }
          this.getProductDataUpdated.next(null);
        },
      });
  }

  checkifidexistsondepartment(newProductId,oldProductId) {
    if (localStorage.getItem("selectedDepartment") != null) {
      var orgId = JSON.parse(localStorage.getItem("selectedOrganisation")).id;
      if (orgId == null) {
        this.authService.logout();
      }
    }
    let token = localStorage.getItem("token");
    const headers = new HttpHeaders({
      Accept: "application/json",
      Authorization: token,
    });
    let params = new HttpParams();
    params = params.append("oldproductid",oldProductId);
    this.http
      .get<any>(
        BackendUrl + "/organisations/" + orgId + "/checkifidexistsondepartment/"+newProductId,
        { headers: headers, params: params})
      .pipe(take(1))
      .subscribe({
        next: (response) => {
          this.getProductDataUpdated.next(response);
        },
        error: (error) => {
          if (error.status === 401) {
            this.authService.logout();
          }
          this.getProductDataUpdated.next(null);
        },
      });
  }

  mailUpdatedSds(id) {
    if (localStorage.getItem("selectedDepartment") != null) {
      var orgId = JSON.parse(localStorage.getItem("selectedOrganisation")).id;
      if (orgId == null) {
        this.authService.logout();
      }
    }
    let token = localStorage.getItem("token");
    const headers = new HttpHeaders({
      Accept: "application/json",
      Authorization: token,
    });
    this.http
      .get<any>(
        BackendUrl + "/organisations/" + id + "/mailupdatedsds/",{headers: headers})
      .pipe(take(1))
      .subscribe({
        next: (response) => {
          this.getProductDataUpdated.next(response);
        },
        error: (error) => {
          if (error.status === 401) {
            this.authService.logout();
          }
          this.getProductDataUpdated.next(null);
        },
      });
  }

  getChangedProducts(orgId,departments,changedProductsFrom,changedProductsTo) {
    let token = localStorage.getItem('token');
    const headers = new HttpHeaders({'Accept':'application/json','Authorization':token});
    let params = new HttpParams();
    params = params.append("departments", departments);
    params = params.append("changedProductsFrom", changedProductsFrom);
    params = params.append("changedProductsTo", changedProductsTo);

    this.http.get(BackendUrl + "/organisations/" + orgId + "/products/getChangedProducts/", {headers: headers, params: params})
      .pipe(take(1)).subscribe({next: response => {
        this.getChangedProductsDataUpdated.next(response);
      },
      error: error => {
        if (error.status === 401)
        {
          this.authService.logout();
        }
        this.getChangedProductsDataUpdated.next(null);
      }
    });


  }

  getStyrenProducts(orgId,departments) {
    let token = localStorage.getItem('token');
    const headers = new HttpHeaders({'Accept':'application/json','Authorization':token});
    let params = new HttpParams();
    params = params.append("departments", departments);

    this.http.get(BackendUrl + "/organisations/" + orgId + "/products/getStyrenProducts/", {headers: headers, params: params})
      .pipe(take(1)).subscribe({next: response => {
        this.getProductStyrenDataUpdated.next(response);
      },
      error: error => {
        if (error.status === 401)
        {
          this.authService.logout();
        }
        this.getProductStyrenDataUpdated.next(null);
      }
    });


  }

  revisionList(orgId,path) {
    let token = localStorage.getItem('token');
    let data = localStorage.getItem('currentUser', );
    if (data == null || data == undefined)
    {
      return;
    }
    else
    {
      var currentUser = JSON.parse(data);
    }
    const headers = new HttpHeaders({'Accept':'application/json','Authorization':token});
    let params = new HttpParams();
    params = params.append("path", path);
    params = params.append("userId", currentUser.id);
    this.http.get(BackendUrl + "/organisations/" + orgId + "/products/revisionList/", {headers: headers, params: params})
      .pipe(take(1)).subscribe({next: response => {
        this.getProductDataUpdated.next(response);
      },
      error: error => {
        if (error.status === 401)
        {
          this.authService.logout();
        }
        this.getProductDataUpdated.next(null);
      }
    });
  }

  /**
   * Start organisation-wide revision.
   * Backend should (on start only):
   * - set organisation.revision_ongoing = 1 and revision_started_at = now
   * - insert products needing revision into the revision queue table
   * - optionally append revision history
   *
   * POST /organisations/{orgId}/revision/start
   */
  startOrganisationRevision(orgId: string | number): Observable<any> {
    const token = localStorage.getItem('token');
    const data = localStorage.getItem('currentUser');
    if (!data) {
      return of(null);
    }
    const currentUser = JSON.parse(data);
    const headers = new HttpHeaders({ Accept: 'application/json', Authorization: token });
    const body = { userId: currentUser.id };

    return this.http
      .post<any>(BackendUrl + '/organisations/' + orgId + '/revision/start', body, { headers })
      .pipe(
        take(1),
        tap((response) => {
          this.getRevisionStatusUpdated.next(response);
          this.getProductDataUpdated.next(response);
        }),
        catchError((error) => {
          if (error.status === 401) {
            this.authService.logout();
          }
          this.getRevisionStatusUpdated.next(null);
          this.getProductDataUpdated.next(null);
          return of(null);
        }),
      );
  }

  /**
   * End organisation-wide revision.
   * Backend should:
   * - set organisation.revision_ongoing = 0 (clear campaign flags)
   * - clear revision queue table for the org
   * - optionally append revision history
   *
   * POST /organisations/{orgId}/revision/end
   */
  endOrganisationRevision(orgId: string | number): Observable<any> {
    const token = localStorage.getItem('token');
    const data = localStorage.getItem('currentUser');
    if (!data) {
      return of(null);
    }
    const currentUser = JSON.parse(data);
    const headers = new HttpHeaders({ Accept: 'application/json', Authorization: token });
    const body = { userId: currentUser.id };

    return this.http
      .post<any>(BackendUrl + '/organisations/' + orgId + '/revision/end', body, { headers })
      .pipe(
        take(1),
        tap((response) => {
          this.getRevisionStatusUpdated.next(response);
          this.getProductDataUpdated.next(response);
        }),
        catchError((error) => {
          if (error.status === 401) {
            this.authService.logout();
          }
          this.getRevisionStatusUpdated.next(null);
          this.getProductDataUpdated.next(null);
          return of(null);
        }),
      );
  }

  /**
   * GET /organisations/{orgId}/revision/status
   * Expected:
   * {
   *   revision_ongoing: 0|1,
   *   revision_started_at: string|null,
   *   products: [{ prod_id, org_id, org_name?, user_id, date }]
   * }
   * Prefer including org_name so other-company "Revideras på" can show a readable name.
   */
  getOrganisationRevisionStatus(orgId: string | number): Observable<any> {
    const token = localStorage.getItem('token');
    const headers = new HttpHeaders({ Accept: 'application/json', Authorization: token });

    return this.http
      .get(BackendUrl + '/organisations/' + orgId + '/revision/status', { headers })
      .pipe(
        take(1),
        tap((response) => this.getRevisionStatusUpdated.next(response)),
        catchError((error) => {
          if (error.status === 401) {
            this.authService.logout();
          }
          this.getRevisionStatusUpdated.next(null);
          return of(null);
        }),
      );
  }

  getRevisionStatusListener() {
    return this.getRevisionStatusUpdated.asObservable();
  }

  /** Persist campaign flags on cached organisation objects in localStorage. */
  applyRevisionOrgState(state: {
    revision_ongoing?: number | boolean | string | null;
    revision_started_at?: string | null;
  } | null): void {
    if (!state) return;

    const hasOngoing = Object.prototype.hasOwnProperty.call(state, 'revision_ongoing');
    const hasStartedAt = Object.prototype.hasOwnProperty.call(state, 'revision_started_at');
    if (!hasOngoing && !hasStartedAt) return;

    const ongoing = hasOngoing
      ? state.revision_ongoing === true ||
        state.revision_ongoing === 1 ||
        state.revision_ongoing === '1'
        ? 1
        : 0
      : undefined;
    const startedAt = hasStartedAt ? (state.revision_started_at ?? null) : undefined;

    for (const key of ['selectedOrganisation', 'rootOrganisation']) {
      const raw = localStorage.getItem(key);
      if (!raw || raw === 'null' || raw === 'undefined') continue;
      try {
        const org = JSON.parse(raw);
        if (ongoing !== undefined) {
          org.revision_ongoing = ongoing;
        }
        if (startedAt !== undefined) {
          org.revision_started_at = startedAt;
        }
        localStorage.setItem(key, JSON.stringify(org));
      } catch {
        // ignore corrupt cache
      }
    }

    this.getRevisionStatusUpdated.next({
      ...(ongoing !== undefined ? { revision_ongoing: ongoing } : {}),
      ...(startedAt !== undefined ? { revision_started_at: startedAt } : {}),
    });
  }

  revisionHistory(orgId) {
    let token = localStorage.getItem('token');
    const headers = new HttpHeaders({'Accept':'application/json','Authorization':token});
    this.http.get(BackendUrl + "/organisations/" + orgId + "/products/revisionHistory/", {headers: headers})
      .pipe(take(1)).subscribe({next: response => {
        this.getProductDataUpdated.next(response);
      },
      error: error => {
        if (error.status === 401)
        {
          this.authService.logout();
        }
        this.getProductDataUpdated.next(null);
      }
    });
  }

  getProductItemHistory(
    orgId: string | number,
    productId: string | number,
    options: { allDepartments: boolean; departmentIds?: (string | number)[] },
  ): Observable<{ ok: boolean; data: unknown }> {
    const token = localStorage.getItem('token');
    const headers = new HttpHeaders({ Accept: 'application/json', Authorization: token });

    let params = new HttpParams().set('allDepartments', options.allDepartments ? 'true' : 'false');
    if (options.allDepartments && options.departmentIds?.length) {
      params = params.set('departmentIds', options.departmentIds.map(String).join(','));
    }

    return this.http
      .get<unknown>(`${BackendUrl}/organisations/${orgId}/products/${productId}/productHistory`, { headers, params })
      .pipe(
        take(1),
        map((response) => ({ ok: true, data: response })),
        catchError((error) => {
          if (error.status === 401) {
            this.authService.logout();
          }
          return of({ ok: false, data: null });
        }),
      );
  }

  getAllForEdit( orgId ) {
    let token = localStorage.getItem( 'token' );
    const headers = new HttpHeaders( {
      'Accept': 'application/json',
      'Authorization': token
    } );
    this.http.get( BackendUrl + "/organisations/" + orgId + "/getallforedit", { headers: headers } ).pipe( take( 1 ) ).
      subscribe( { next: response => {
        this.getProductsDataUpdated.next( response );
      },
      error: error => {
        if (error.status === 401) {
          this.authService.logout();
        }
        this.getProductsDataUpdated.next( null );
      }
    } );
  }

  saveAllEditedProducts(orgId, info){
    if ( localStorage.getItem( "selectedOrganisation" ) != null) {
      var orgId = JSON.parse( localStorage.getItem( "selectedOrganisation" ) ).id;
      if ( orgId == null ) {
        this.authService.logout();
      }
    }
    let token = localStorage.getItem("token");
    const headers = new HttpHeaders( {
      Accept: "application/json",
      Authorization: token,
    } );

    this.http
      .put< any > (
        BackendUrl + "/organisations/" + orgId + "/savealledited",
        info,
        {
          headers: headers
        } )
      .pipe( take( 1 ) )
      .subscribe( {
        next: ( response ) => {
          this.getProductDataUpdated.next( response );
        },
        error: ( error ) => {
          if ( error.status === 401 ) {
            this.authService.logout();
          }
          this.getProductDataUpdated.next( null );
        },
      } );
  }

  historyStatisticsReport(orgId, allDep, date1, date2, referenceDate?: string | null) {
    let params = new HttpParams();
    params = params.append("allDep", allDep);
    params = params.append("date1", date1);
    params = params.append("date2", date2);
    if (referenceDate) {
      params = params.append("referenceDate", referenceDate);
    }

    let token = localStorage.getItem('token');
    const headers = new HttpHeaders({'Accept':'application/json','Authorization':token});
    this.http.get(BackendUrl + '/organisations/' + orgId + '/products/gethistorystatistics/',
      {
        headers: headers,
        params: params
      }).
      pipe(take(1)).
      subscribe({next: response => {
        this.getHistoryStatisticsUpdated.next(response);
      },
      error: error => {
        if (error.status === 401) {
          this.authService.logout();
        }
          this.getHistoryStatisticsUpdated.next(null);
      }
    });
  }

  getRestriktionListFromTwoDates(orgId, allDep, date1, date2, referenceDate?: string | null) {
    let params = new HttpParams();
    params = params.append("allDep", allDep);
    params = params.append("date1", date1);
    params = params.append("date2", date2);
    if (referenceDate) {
      params = params.append("referenceDate", referenceDate);
    }

    let token = localStorage.getItem('token');
    const headers = new HttpHeaders({'Accept':'application/json','Authorization':token});
    this.http.get(BackendUrl + '/organisations/' + orgId + '/products/getRestriktionListFromTwoDates/',
      {
        headers: headers,
        params: params
      }).
      pipe(take(1)).
      subscribe({next: response => {
        this.getProductRestTwoDatesUpdated.next(response);
      },
      error: error => {
        if (error.status === 401) {
          this.authService.logout();
        }
          this.getProductRestTwoDatesUpdated.next(null);
      }
    });
  }

  getNumberOfProducts(orgId) {
    let token = localStorage.getItem('token');

    const headers = new HttpHeaders({'Accept':'application/json','Authorization':token});

    this.http.get(BackendUrl + '/organisations/' + orgId + '/products/getNumberOfProducts/', { headers: headers })
      .pipe(take(1)).subscribe({next: response => {
        this.getProductNumberDataUpdated.next(response);
      },
      error: error => {
        if (error.status === 401)
        {
          this.authService.logout();
        }
        this.getProductNumberDataUpdated.next(null);
      }
    });
  }

  removeSingleProductDepartment(product) {
    let token = localStorage.getItem('token');

    if (product.department != null )
    {
      var orgId = product.department;
      if (orgId == null)
      {
        this.authService.logout();
      }

      const headers = new HttpHeaders({'Accept':'application/json','Authorization':token});

      let params = new HttpParams();
      params = product;

      this.http.delete<any>(BackendUrl + "/organisations/" + orgId + "/products/" + product.productId, {headers: headers, params:params}).pipe(take(1)).subscribe({next: response => {

          this.getProductDataUpdated.next(true);
          this.notifyProductListChanged();
        },
        error: error => {
          if (error.status === 401)
          {
            this.authService.logout();
          }
          this.getProductDataUpdated.next(true);
        }
      });
    }
  }

  public getProductsDataListener() {
    return this.getProductsDataUpdated.asObservable();
  }

  public getProductDataListener() {
    return this.getProductDataUpdated.asObservable();
  }

  public getAllProductDataListener() {
    return this.getAllProductDataUpdated.asObservable();
  }

  public getProductSingleDataListener() {
    return this.getProductSingleDataUpdated.asObservable();
  }

  public getProductRestDataListener() {
    return this.getProductRestDataUpdated.asObservable();
  }

  public getProductHistoryDataListener() {
    return this.getProducthistoryDataUpdated.asObservable();
  }

  public getProductPphraseDataListener() {
    return this.getProductPphraseDataUpdated.asObservable();
  }

  public getProductCphraseDataListener() {
    return this.getProductCphraseDataUpdated.asObservable();
  }

  public getProductCasDataListener() {
    return this.getProductCasDataUpdated.asObservable();
  }

  public getProductSubstanceGroupsDataListener() {
    return this.getProductSubstanceGroupsDataUpdated.asObservable();
  }

  public getProductRestrictionDataListener() {
    return this.getProductRestrictionDataUpdated.asObservable();
  }

  public getProductGroupDataListener() {
    return this.getProductGroupDataUpdated.asObservable();
  }

  public getProductCategoryDataListener() {
    return this.getProductCategoryDataUpdated.asObservable();
  }

  public getProductLangDataListener() {
    return this.getProductLangDataUpdated.asObservable();
  }

  public getProductCargoDataListener() {
    return this.getProductCargoDataUpdated.asObservable();
  }

  public getProductDepartmentDataListener() {
    return this.getProductDepartmentDataUpdated.asObservable();
  }

  public getProductPictureDataListener() {
    return this.getProductPictureDataUpdated.asObservable();
  }

  public getChangedProductsDataListener() {
    return this.getChangedProductsDataUpdated.asObservable();
  }

  public getProductStyrenDataListener() {
    return this.getProductStyrenDataUpdated.asObservable();
  }

  public getDeletedProductsForCustomerListener() {
    return this.getDeletedProductsForCustomerUpdated.asObservable();
  }

  public getProductAllSubListener() {
    return this.getProductsAllSupUpdated.asObservable();
  }

  public getProductAllSubTopListener() {
    return this.getProductsAllSupTopUpdated.asObservable();
  }

  public getProductCountSubListener() {
    return this.getProductsCountUpdated.asObservable();
  }

  public getDataSheetUpdatedListener() {
    return this.getDataSheetUpdated.asObservable();
  }

  public getSdsDataUpdatedListener() {
    return this.getSdsDataUpdated.asObservable();
  }

  public getGrbDataUpdatedListener() {
    return this.getGrbDataUpdated.asObservable();
  }

  public getExtSdsDataUpdatedListener() {
    return this.getExtSdsDataUpdated.asObservable();
  }

  public getHistoryStatisticsListener() {
    return this.getHistoryStatisticsUpdated.asObservable();
  }

  public getProductRestTwoDatesDataListener() {
    return this.getProductRestTwoDatesUpdated.asObservable();
  }

  public getLogoListener() {
    return this.getLogoUpdated.asObservable();
  }

  public getProductNumberDataListener() {
    return this.getProductNumberDataUpdated.asObservable();
  }

  public getCheckProductDataListener() {
    return this.getCheckProductDataUpdated.asObservable();
  }

  askAIProductQuestion(productId: string, question: string, lang: string): Observable<any> {
    let token = localStorage.getItem("token");

    if (localStorage.getItem("selectedDepartment") != null) {
      var orgId = JSON.parse(localStorage.getItem("selectedDepartment")).id;
      if (orgId == null) {
        this.authService.logout();
        return throwError(() => new Error("No organization selected"));
      }

      const headers = new HttpHeaders({
        Accept: "application/json",
        Authorization: token,
      });

      const body = {
        product_id: productId,
        question: question,
        language: lang
      };

      return this.http.post<any>(
        BackendUrl + "/organisations/" + orgId + "/products/ai-question",
        body,
        { headers: headers }
      );
    }
    return throwError(() => new Error("No department selected"));
  }
}
